import { AxiosResponse } from "axios";

export const DEFAULT_ACCEPTED_FILE_TYPES =
  ".pdf, .txt, .docx, .png, .jpeg, .csv, .jpg, .xls, .xlsx, .ppt, .pptx";

export const downloadFile = async (data: Blob, filename: string) => {
  try {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(data);
    link.download = filename;
    link.click();
  } catch (error) {
    console.error("Failed to download file", error);
  }
};

const sanitizeDownloadFileNamePart = (value: string) =>
  value
    .replace(/[\r\n]+/g, " ")
    .replace(/[/\\:*?"<>|]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/**
 * Downloaded document names follow the org email convention:
 * "[{Org name}]_{device_name}_{name}.ext". Global documents omit the device
 * part; callers pass the document title or original upload name as `baseName`.
 */
export const buildDownloadFileName = ({
  baseName,
  deviceName,
  organizationName,
}: {
  baseName: string;
  deviceName?: string | null;
  organizationName?: string | null;
}) => {
  const org = sanitizeDownloadFileNamePart(organizationName ?? "");
  const parts = [
    org ? `[${org}]` : "",
    sanitizeDownloadFileNamePart(deviceName ?? ""),
    sanitizeDownloadFileNamePart(baseName),
  ];

  return parts.filter(Boolean).join("_");
};

export const getFilenameFromResponse = (
  file: AxiosResponse<any, any> | undefined | null
) => {
  if (!file || !file?.headers) return undefined;

  const contentDisposition = file.headers["content-disposition"];
  if (!contentDisposition) return undefined;

  const filenamePart = contentDisposition
    .split(";")
    .find((n: string) => n.includes("filename="));

  if (!filenamePart) return undefined;

  const fullFilename = filenamePart
    .replace("filename=", "")
    .replace(/"/g, "")
    .trim();

  const underscoreIndex = fullFilename.indexOf("_");
  if (underscoreIndex !== -1) {
    return fullFilename.substring(underscoreIndex + 1);
  }

  return fullFilename;
};

export function convertSVGtoImage(svgString: string) {
  return new Promise((resolve, reject) => {
    // var blob = new Blob([svgString], { type: "image/svg+xml" });
    var url = "data:image/svg+xml;base64," + btoa(svgString);

    let img = new Image();
    // img.crossOrigin = "anonymous";
    img.src = url;

    img.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = img.width * 1.3;
      canvas.height = img.height * 2;
      var ctx = canvas.getContext("2d");
      if (!ctx) throw new Error("Could not get canvas context");

      ctx.drawImage(img, 0, 0);

      try {
        var dataURL = canvas.toDataURL();
        if (dataURL === "data:,") {
          reject(new Error("Canvas is blank"));
        } else {
          resolve(dataURL);
        }
      } catch (e) {
        reject(e);
      }

      URL.revokeObjectURL(url);
    };

    img.onerror = function () {
      reject(new Error("Image loading error"));
      URL.revokeObjectURL(url);
    };
  });
}

export const removeSpecialCharactersFomFilename = (file: File) =>
  new File([file], file.name.replace(/[^\w.]|_/g, ""), {
    type: file.type,
  });
